var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphqlapi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E535AB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,37.8l-1.8-1L24.6,2.2l1.8,1L6.4,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,34h39.8V36H4.2L4.2,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,46.6L5,35.1l1-1.8L26,44.8L25,46.6z M42.3,16.6L22.4,5.1l1-1.8l19.9,11.5L42.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,16.6l-1-1.8L25,3.3l1,1.8L6.1,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,37.8L22,3.2l1.8-1l19.9,34.5L41.9,37.8z M5.8,13.5h2.1v23H5.8V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,13.5h2.1v23h-2.1V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,45.8l-0.9-1.6l17.3-10l0.9,1.6L24.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,37.2c-1.2,2.1-3.9,2.8-5.9,1.6c-2.1-1.2-2.8-3.9-1.6-5.9s3.9-2.8,5.9-1.6C45.8,32.4,46.5,35.1,45.3,37.2  M10.6,17.1c-1.2,2.1-3.9,2.8-5.9,1.6c-2.1-1.2-2.8-3.9-1.6-5.9S6.9,10,9,11.2C11.1,12.4,11.8,15.1,10.6,17.1 M3.1,37.2 c-1.2-2.1-0.5-4.7,1.6-5.9c2.1-1.2,4.7-0.5,5.9,1.6c1.2,2.1,0.5,4.7-1.6,5.9C6.9,40,4.3,39.2,3.1,37.2 M37.8,17.1 c-1.2-2.1-0.5-4.7,1.6-5.9c2.1-1.2,4.7-0.5,5.9,1.6c1.2,2.1,0.5,4.7-1.6,5.9C41.6,19.9,38.9,19.2,37.8,17.1 M24.2,49.3 c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3C28.5,47.4,26.6,49.3,24.2,49.3 M24.2,9.3c-2.4,0-4.3-1.9-4.3-4.3 s1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3S26.6,9.3,24.2,9.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphqlapi);
export default __webpack_public_path__ + "static/media/graphqlapi.830807fbb05f0bcd3d7431b8f6a737f2.svg";
export { ForwardRef as ReactComponent };